import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { SharedDataService } from '../../services/shared-data.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-single-choice-field',
    templateUrl: './single-choice-field.component.html',
    styleUrls: ['./single-choice-field.component.scss'],
})
export class SingleChoiceFieldComponent implements OnInit {
    UtilService = UtilService;

    // Tracks which questions have already had their post-relaunch radio-button
    // correction applied (see ngAfterViewInit). Without this, re-showing a
    // question via Show/Hide logic later in the same session recreates this
    // component and would incorrectly re-force its answer from the original
    // relaunch snapshot, even after the user has deliberately cleared it by
    // hiding it. Static so it's shared across every instance of this component
    // for the lifetime of the app session, not just this one question's.
    private static relaunchCorrectedQuestionIds = new Set<any>();

    @Input() inputName: string;
    @Input() form: UntypedFormGroup;
    @Input() list: Array<any>;
    @Input() isShowAnswerScoreEnabled: boolean;

    @Output() answerUpdated = new EventEmitter<any>();
    @Input() questionId: string;
    @Input() preValue: string;

    @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

    constructor(public sharedDataService: SharedDataService, private cdr: ChangeDetectorRef) {}
    ngOnInit() {
        //console.log("scs prevalue:", this.preValue, typeof(this.preValue), this.inputName, this.form.get(this.inputName), this.sharedDataService.relaunchInfo)
        if (this.preValue) {
            this.form.get(this.inputName)?.setValue(this.preValue);
        }
        
    }
    ngAfterViewInit() {
        try{
            if ((this.sharedDataService.relaunchInfo?.relaunch || this.sharedDataService.dedicatedmodeRelaunchData?.isRelaunch )  && typeof(this.preValue) === "number"
                && !SingleChoiceFieldComponent.relaunchCorrectedQuestionIds.has(this.questionId)) {
                SingleChoiceFieldComponent.relaunchCorrectedQuestionIds.add(this.questionId);
                const radioBtns = document.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
                setTimeout(()=>{
                    radioBtns.forEach((radio)=>{ 
                        if(radio.id.toString() === this.preValue.toString()){
                            radio.checked = true
                            //radio.setAttribute('checked','true')
                            radio.classList.add("relaunch-check") //backup render
                            this.resetRLCheck.init = true;
                            radio.dispatchEvent(new Event('change')) 
                        }
                    })
                },300)
            }
        } catch (e){
            console.error("SCS relaunch error: ", e)
        }
    }

    updateState(event: any) {
        this.answerUpdated.emit(event);
    }
    ngOnChanges(){

    }

    trackByFn(index: number, item: any): any {
        return item.answerChoiceAttributeHeaders[0].answerChoiceAttributeHeaderId;
    }
    onSCSClick($event){
        if(this.sharedDataService.isMobile){
          const section = document.querySelector('section.summary-display');
          if (section) {
            const SCS = event.target as HTMLInputElement;
            SCS.dispatchEvent(new Event('click')); 
          }
        }
      }
    resetRLCheck ={init:false, firstRun:true} 
    private lastExecution = 0;
	selectRadio(event: Event, selectedValue: any) {
        const now = Date.now();
        if (now - this.lastExecution < 100) {
            return;
        }
        if(this.resetRLCheck.init && this.resetRLCheck.firstRun){
            try{
            const inputElement = document.getElementById(this.preValue) as HTMLInputElement;
            inputElement.classList.remove("relaunch-check")
            } catch{}
            this.resetRLCheck.firstRun = false
        }


        this.lastExecution = now;

        this.sharedDataService.isUserClickingSingleChoice = true;

		const target = event.target as HTMLInputElement;

		const currentValue = this.form.get(this.inputName)?.value;

		if (target.checked) {
			if (currentValue === selectedValue) {
				// If the clicked radio button is already checked, uncheck it
				target.checked = false;
				this.form.get(this.inputName)?.setValue(null);
				this.sharedDataService.selectedChoice = selectedValue;
			} else {
				// If another radio button was checked, update the form control
				this.form.get(this.inputName)?.setValue(selectedValue);
				this.sharedDataService.selectedChoice = selectedValue;
			}
		} else {
			// If the clicked radio button was unchecked, check it and update the form control
			target.checked = true;
			this.form.get(this.inputName)?.setValue(selectedValue);
			this.sharedDataService.selectedChoice = selectedValue;
		}

        setTimeout(() => {
            this.sharedDataService.isUserClickingSingleChoice = false;
        }, 100);
	}
}
